<template>
  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <div v-for="(opt, index) in values" :key="index" :class="'col-xs-' + opt.grid">
          <div class="form-group" v-if="!['row'].includes(opt.type)">
            <hr v-if="opt.type=='divider'">
            <div v-else>
              <div v-if="specialReportColumnTypeComponents[getFieldTypeFromFieldName(opt.name)]">
                <p>{{ opt.title }}:</p>
                <component :is="specialReportColumnTypeComponents[getFieldTypeFromFieldName(opt.name)]" :data="{td: opt.value}" />
              </div>
              <div v-else-if="opt.type == 'signature' || isSignatureDisplayType(index)">
                <p>{{ opt.title }}:</p>
                <img :src="opt.raw" alt="">
              </div>
              <div v-else-if="isFileDisplayType(index)">
                <p>{{ opt.title }}:</p>
                <strong>{{ getFileNameFromValue(opt.value) }}</strong>
              </div>
              <p v-else><span v-html="opt.title">: </span> <strong v-if="!['text-entry','signature'].includes(opt.type)" v-html="opt.value"></strong></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import specialReportColumnTypeComponents from "@/utils/specialReportColumnTypeComponents";
  import { getFieldTypeFromFieldName } from "@/utils/functions";

  export default {
    name: 'vue-form-view',
    props: ['schema', 'values'],
    computed: {
      specialReportColumnTypeComponents(){
        return specialReportColumnTypeComponents
      },
      getFieldTypeFromFieldName() {
        return getFieldTypeFromFieldName
      }
    },
    methods: {
      isSignatureDisplayType(index){
        return this.schema[index].displayType === 'signature'
      },
      isFileDisplayType(index){
        return this.schema[index].displayType === 'file'
      },
      getFileNameFromValue(value) {
        const values = JSON.parse(value);
        if (Array.isArray(values)){
          return values.map(value => {
            return value.name
          }).join(', ')
        }

        return value
      }
    }
  }
</script>

<style scoped>
  p {
    margin: 5px 0;
  }

  .form-group {
    margin-bottom: 5px;
  }

  input[type='date'] {
    text-transform: uppercase;
  }
</style>



// WEBPACK FOOTER //
// VueFormView.vue?1b2ca1c4